import axios from 'axios'

export default  {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    create({commit}, billingData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/projects/${billingData.project_id}/billings`, billingData)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    update({commit}, billingData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/projects/billings/${billingData.id}`, billingData)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },

  getters: {},
}
